export default function TrustSection() {
  const trustPoints = [
    {
      icon: 'ri-home-heart-line',
      text: 'No unnecessary damage to your property',
    },
    {
      icon: 'ri-radar-line',
      text: 'Accurate leak detection using professional equipment',
    },
    {
      icon: 'ri-shield-check-line',
      text: 'Honest recommendations — no upsells',
    },
    {
      icon: 'ri-flashlight-line',
      text: 'Fast response — same-day service available',
    },
  ];

  return (
    <section className="bg-white border-b border-gray-100 py-8 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-6 lg:gap-10">
          {/* Label */}
          <div className="flex-shrink-0 text-center lg:text-left">
            <span className="inline-block bg-cyan-500 text-white text-xs font-black uppercase tracking-widest px-4 py-2 rounded-full mb-1 lg:mb-0">
              Why Choose Us
            </span>
          </div>

          {/* Divider - desktop only */}
          <div className="hidden lg:block w-px h-12 bg-gray-200 flex-shrink-0"></div>

          {/* Trust Points */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full">
            {trustPoints.map((point, index) => (
              <div
                key={index}
                className="flex items-center gap-3"
              >
                <div className="w-9 h-9 flex items-center justify-center bg-cyan-50 rounded-lg flex-shrink-0">
                  <i className={`${point.icon} text-lg text-cyan-600`}></i>
                </div>
                <p className="text-sm font-semibold text-[#0f1f3d] leading-tight">
                  {point.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
